import Vue from "vue"
import VueRouter from 'vue-router' 
Vue.use(VueRouter)

//解决连续多次点击跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
	  mode: 'history',
    routes:[
        {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/about',
          name: 'about',
          component: ()=>import('../views/about'),
        },
        {
          path: '/product',
          name: 'product',
          component: ()=>import('../views/product'),
        },
        {
          path: '/productclassFy',
          name: 'productclassFy',
          component: ()=>import('../views/productclassFy'),
        },
        {
          path: '/productDtl',
          name: 'productDtl',
          component: ()=>import('../views/productDtl'),
        },
        {
          path: '/use',
          name: 'use',
          component: ()=>import('../views/use'),
        },
        {
          path: '/useDtl',
          name: 'useDtl',
          component: ()=>import('../views/useDtl'),
        },
        {
          path: '/news',
          name: 'news',
          component: ()=>import('../views/news'),
        },
        {
          path: '/newsDtl',
          name: 'newsDtl',
          component: ()=>import('../views/newsDtl'),
        },
        {
          path: '/contact',
          name: 'contact',
          component: ()=>import('../views/contact'),
        }

    ]
})


